export default __webpack_public_path__ + "static/media/habano-5Closed.d5759770.jpg";